// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1Tu8P","ratingBlock":"styles_ratingBlock__2_yeA","rating":"styles_rating__1SCvB","star":"styles_star__tgtSr"};